import './input.css'
export default function Input({ label, value, onChange, placeholder, disabled = false, type = "text" ,name,erroText, helpText, minLength,required,style}){

    const error = false
    // value && minLength && value.length < minLength
    const erroMsg = error ? erroText:''
    return(
    <div 
        className="field-group">
        {label && <label className={`field-label ${error ? 'label-error':''}`}>{label}</label>}
        <input 
        style={{...style}}
        type={type}
        className={`field-input ${error ? 'input-error':''}`}
        minLength={minLength}
        value={value} 
        onChange={onChange} 
        placeholder={placeholder}
        disabled={disabled}
        name={name}
        required={required}
    />
    {erroMsg && (
        <span className={`helper-text ${error ? 'text-error':''}`}>
            {erroMsg}
        </span>)}
    {(!erroMsg && helpText) && (
        <span className={`helper-text ${error ? 'text-error':''}`}>
            {helpText}
        </span>)}
    
    </div>
);
}
